import * as types from './action-types';
import state from "./state";

let initialState = state;

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FETCH_NOTIFICATION_TYPE:
      return {
        ...state,
        type: types.SET_FETCH_NOTIFICATION_TYPE
      };
    case types.DEL_FETCH_NOTIFICATION_TYPE:
      return {
        ...state,
        type: ''
      };
    case types.SET_FETCH_ACCIDENT_NOTIFICATION_TYPE:
      return {
        ...state,
        type: types.SET_FETCH_ACCIDENT_NOTIFICATION_TYPE
      };
    case types.DEL_FETCH_ACCIDENT_NOTIFICATION_TYPE:
      return {
        ...state,
        type: ''
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/notification/reducers.js